import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"

const GET_ENGAGEMENT = gql`
  query GetEngagementQuery($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      allowedToSubmitExpenses
      company {
        id
        approver {
          id
          avatarUrl
          name
          email
        }
        name
      }
      contract {
        id
        billingType
        allowedToSubmitExpenses
      }
      countryCode
      directHire
      employment {
        id
        salaryCurrencyCode
        countryCode
      }
      engagementType
      holidaysDataAvailable
      isPayrollTeamMember
      oysterExpensesEnabled
      paymentMethodManagementEnabled
      payrollCurrencyCode
      role
      state
      subdivisionCode
      timeOffManagementEnabled
      timeTrackingEnabled
      withValidRegionAddress
    }
  }
`

export const useEngagement = (engagementId: string) => {
  return useQuery(GET_ENGAGEMENT, {
    variables: {
      engagementId,
    },
    ignoredErrorCodes: ["429"],
  })
}
